import { values } from 'lodash';

const markets: string[] = [
  '1st Roshan',
  '2nd Period Odd/Even - Away Team',
  'Away Team To Keep A Clean Sheet 1st Period',
  'Will The First Scoring Team Win?',
  'Both Teams To Score 1st Half',
  'Winning Margin',
  'Odd/Even Kills',
  'Away Team To Keep A Clean Sheet 2nd Period',
  'Home Team To Win From Behind',
  'First Score Method - Home Team',
  'Under/Over 1st Period - Home Team',
  'Under/Exactly/Over',
  'Total Fouls Committed',
  'Away Win No Bet',
  'Will There Be An Ace? - 3rd Period',
  '1X2 Halftime',
  'Asian Handicap 2nd Period',
  'Will There Be Overtime? - 2nd Period',
  'Will Game Go to Shootout?',
  'Last Corner',
  'Exact Winning Margin - 3rd Period',
  'Odd/Even - Home Team',
  'Home Win No Bet',
  'Game Duration',
  '5th Period Winner Home/Away',
  'Team With Most 2nd Half Corners',
  '2nd Period Race To',
  '4th Period Odd/Even - Away Team',
  'Odd/Even Rounds 2nd Period',
  '3rd Period - 1st Roshan',
  'Correct Score 2nd Period',
  'Highest Scoring Half',
  'Multiple Correct Score',
  '3rd Period Winner',
  'To Win Either Half',
  'Team Scoring First To Win The Match',
  'Last Player To Score',
  'In What Half First Goal Will Be Scored?',
  'Will A Goal Be Scored In Both Halves?',
  'Asian Handicap 4th Period Including Overtime',
  'Under/Over Games',
  '1X2 Corners 2nd Half',
  '2nd Period - 1st Barracks',
  'Both Teams to kill a Dragon - 2nd Period',
  'Under/Exactly/Over - Home Team',
  'Away Team to Score',
  'Asian Handicap Including Overtime',
  'Will There Be An Ace?',
  '2nd Period Odd/Even - Home Team',
  'Under/Over 2nd Period - Home Team',
  '3rd Period Odd/Even',
  'Winning Margin Range Including Overtime',
  'Away Team Number Of Goals In 2nd Half',
  '1st 5 Innings Under/Over',
  'Home Team Number Of Goals',
  '1X2 Corners',
  'Under/Over 3rd Period',
  'Number of Goals 2nd Half',
  'Asian Under/Over 1st Period',
  'Odd/Even Halftime',
  'Under/Over - Away Team',
  'Under/Over 1st Period - Away Team',
  'Odd/Even 2nd Half',
  'Home Team To Score In Both Halves',
  '4th Period Winner',
  'To Qualify',
  'Correct Score Including Overtime',
  'Under/Exactly/Over - 1st Period',
  'Exact Winning Margin - 2nd Period',
  'Both Teams to kill a Dragon - 3rd Period',
  'Under/Over Halftime - Away Team',
  'Under/Over - Home Team Including Overtime',
  'In Which Half Home Team Will Score First Goal?',
  'Corners Range',
  '1st Tower',
  'Odd/Even Kills - 1st Period',
  '1st Period Odd/Even - Home Team',
  'Both Teams To Score 2nd Half',
  '3rd Period Odd/Even - Home Team',
  'Double Chance',
  '3rd Period Odd/Even - Away Team',
  'Odd/Even Rounds 1st Period',
  'Under/Over Yellow Cards - 1st Half',
  'Under/Over Yellow Cards - Home Team 2nd Half',
  '2nd Period - 1st Turret',
  'In Which Half Home Team Will Score More Goals?',
  'Under/Over 4th Period - Away Team',
  'Will There Be A Knife Kill?',
  'Both Teams to kill a Inhibitor - 2nd Period',
  'Home Team to Score 1st Half',
  'Both Teams to kill a Inhibitor - 3rd Period',
  'Corners Handicap',
  'Away Team To Win At Least One Half',
  'First Yellow Card',
  '10 Minute Under/Over - Cards',
  'Will The Match Be Decided In 5th Set?',
  'Odd/Even Including Overtime',
  'Away Team Number Of Goals In 1st Half',
  'Asian Handicap 4th Period',
  'Will There Be An Ace? - 1st Period',
  'Exact Winning Margin - 1st Period',
  'Asian Handicap Halftime',
  'Home Team Number Of Goals In 2nd Half',
  'Under/Over Corners - 1st Half',
  'Away Team Win To Nil',
  '12 Halftime',
  '15 Minute Result',
  '4th Period Odd/Even - Home Team',
  'Asian Handicap 3rd Period',
  'Both Teams to kill a Dragon - 1st Period',
  'First Player To Score',
  '3rd Period - 1st Turret',
  '1st Blood',
  '1st Period Winner Home/Away',
  '12 Including Overtime',
  '3rd Period Race To',
  'To Win From Behind',
  'First Team To Score',
  'Under/Over 2nd Period - Away Team',
  'Correct Score 3rd Period',
  'Correct Score 1st Period',
  'Home Team Number Of Goals In 1st Half',
  'Under/Over Halftime',
  'Under/Exactly/Over - Away Team',
  'Double Chance 3rd Period',
  '3rd Period - 1st Barracks',
  'Under/Over 4th Period',
  'Under/Over Corners - Away Team',
  'Double Chance 1st Period',
  '3-Way Winning Margin Range Including Overtime',
  'To Score In Both Halves',
  'Asian Handicap 2nd Half',
  'European Handicap Corners',
  'Away Team to Score 2nd Half',
  'Under/Over Corners 1st Half - Home Team',
  '1st Period Home Team Win To Nil',
  'First Card',
  'HT/FT',
  '1st 5 Innings Winner',
  'Race To Kills - 3rd Period',
  '1st Half 1X2 And Under/Over',
  'Under/Over 3rd Period - Home Team',
  '12 And Under/Over',
  'Total Corners',
  'Number of Goals 1st Half',
  'First Team To Score 1st Period',
  'Home Team To Keep A Clean Sheet 1st Period',
  'Last Away Player To Score',
  'Exact Winning Margin',
  'First Score Method',
  'Under/Over Corners - Home Team',
  'Under/Over Yellow Cards - Away Team',
  'Draw In Both Halves',
  '4th Period Winner Home/Away',
  '1st 7 Innings Asian Handicap',
  'Correct Score',
  'Any Player To Score At Least 3 Goals',
  '1X2 2nd Half',
  '1X2',
  'Under/Over And Both Teams To Score',
  '10 Minute Under/Over',
  'Under/Over 4th Period - Home Team',
  'Will The Game Go To Overtime?',
  '1st Period Winner',
  'Asian Handicap 1st Period',
  'Will There Be Overtime? - 1st Period',
  'Total Corners - 2nd Half',
  ' Either Team to Score 3 Unanswered Times',
  'Will Be An Own Goal?',
  'Away Team To Win From Behind',
  'Home Team To Win Both Halves',
  'Odd/Even - Away Team',
  'Away Team Number Of Goals',
  'Goalscorer (Match)',
  'HT/FT Including Overtime',
  'Under/Over Halftime - Home Team',
  'To Win Both Halves',
  '2nd Period Winner',
  '1X2 Corners 1st Half',
  'Under/Over - Away Team Including Overtime',
  'Will there be a knife kill? - 1st Period',
  '2nd Period Duration',
  '3rd Period - 1st Blood',
  '12',
  'Double Chance 2nd Period',
  'Double Chance 4th Period',
  'Under/Over Corners 2nd Half - Home Team',
  'Total Corners - 1st Half',
  '1st Period - 1st Roshan',
  'European Handicap',
  'Under/Over - 2nd Half',
  'Exact 1X2 And Both Teams To Score',
  'Will A Red Card Be Shown?',
  'Corners - Under/Exactly/Over',
  'Under/Over',
  '3rd Period Winner Home/Away',
  '1st Period - 1st Tower',
  '3rd Period - 1st Tower',
  'Under/Over - Home Team',
  'Double Chance 2nd Half',
  'First Away Player To Score',
  'Asian Under/Over',
  'Home Team to Score',
  'Points Range',
  'First Home Player To Score',
  'Home Team To Win At Least One Half',
  'European Handicap Halftime',
  'Away Team To Score In Both Halves',
  '1st Period Odd/Even - Away Team',
  'In Which Half Away Team Will Score More Goals?',
  'Both Teams To Score In Both Halves',
  'Last Team To Score',
  'Will There Be A Score In The 1st Inning',
  'Under/Over Cards',
  'In Which Half Away Team Will Score First Goal?',
  'Away Team To Keep A Clean Sheet',
  '12 2nd Half',
  'Under/Over Corners 2nd Half - Away Team',
  'Player To Score 3 Or More Goals',
  'Highest Scoring Period',
  'Player To Score In Anytime',
  'Goals Range 1st Period',
  'Last Home Player To Score',
  'To Keep a Clean Sheet',
  'Under/Over 3rd Period - Away Team',
  'Both Teams To Score',
  '1st Barracks',
  'First Corner',
  'Race To Kills - 2nd Period',
  'Both Teams to kill a Inhibitor - 1st Period',
  '1st Period Duration',
  'Will there be a knife kill? - 2nd Period',
  'Odd/Even Kills - 3rd Period',
  '1st Period - 1st Blood',
  '10 Minute Result',
  '1st Period Race To',
  'First Team To Score - Home/Away',
  'Under/Over Yellow Cards - Home Team 1st Half',
  'Special Team or Defensive Touchdown Scored',
  'Under/Over 1st Period',
  'Number of Goals',
  'Under/Over 2nd Period',
  'Under/Over 2nd Half Including Overtime',
  '10 Minute Under/Over - Corners',
  '1st Period - 1st Turret',
  '2nd Period Odd/Even',
  'Under/Over Yellow Cards',
  'Will A Penalty Be Awarded?',
  '1X2 And Under/Over',
  'Home Team Win To Nil',
  'Under/Over Yellow Cards - Away Team 2nd Half',
  'Home Team To Keep A Clean Sheet',
  'Under/Over Including Overtime',
  'Under/Over Sets',
  'Under/Exactly/Over - 1st Half',
  'Will There Be An Ace? - 2nd Period',
  '2nd Period Winner Home/Away',
  '3rd Period Duration',
  'Odd/Even',
  '1st Period Odd/Even',
  'Player To Score 2 Or More Goals',
  '3-Way Winning Margin Range',
  'Under/Over Yellow Cards - Home Team',
  'Will There Be Overtime? - 3rd Period',
  'Away Team To Win Both Halves',
  'Odd/Even Kills - 2nd Period',
  '1st 5 Innings Asian Handicap',
  'Outright Winner',
  '2nd Period - 1st Roshan',
  'Game Range 3rd Period',
  'Home Team to Score 2nd Half',
  '2nd Period - 1st Tower',
  '30 Minute Result',
  'Under/Over Yellow Cards - 2nd Half',
  'Player To Sscore 3 Or More Goals',
  'Team With Highest Scoring Period',
  '1X2 And Under/Over 5 way',
  'Exact Winning Margin Including Overtime',
  'Corners Handicap - 1st Half',
  'To Win Not to Nil',
  'Will Be a Tie-Break In The Match?',
  'First Team To Score 2nd Half',
  'Under/Over Yellow Cards - Away Team 1st Half',
  'Asian Handicap Games',
  '1st Half Home Team Win To Nil',
  'Home Team To Keep A Clean Sheet 2nd Period',
  'To Win To Nil',
  '2nd Period - 1st Blood',
  'Odd/Even Rounds 3rd Period',
  'First Score Method - Away Team',
  'Will there be a knife kill? - 3rd Period',
  'Goals Range 2nd Period',
  'Asian Handicap',
  '4th Period Odd/Even',
  'Away Team to Score 1st Half',
  '1st Period - 1st Barracks',
  'Race To',
  'Odd/Even Rounds',
  'Team To Call First Time Out',
  'Race To Kills - 1st Period',
  'Asian Handicap Bookings',
  'Goals Range',
];

export const bookies: {
  [id: string]: {
    id: string;
    name: string;
    code: string;
    url: string;
    logoUrl: string;
    isActive: boolean;
  };
} = {
  biefnarp0dp6sqioj4g0: {
    id: 'biefnarp0dp6sqioj4g0',
    code: 'PINNACLE',
    name: 'Pinnacle Sports',
    logoUrl:
      'https://tipsterchat-prod-public.s3-eu-west-1.amazonaws.com/bookies/logos/Pinnacle.svg',
    url: 'https://www.bet365.com/olp/open-account?affiliate=365_00925473',
    isActive: true,
  },
  bf8788ghmrv8bg1f28ig: {
    id: 'bf8788ghmrv8bg1f28ig',
    code: 'BET365',
    name: 'Bet365',
    logoUrl:
      'https://tipsterchat-prod-public.s3-eu-west-1.amazonaws.com/bookies/logos/Bet365.svg',
    url: '',
    isActive: true,
  },
  bf8788ghmrv8bg1f28kg: {
    id: 'bf8788ghmrv8bg1f28kg',
    code: 'BWIN',
    name: 'Bwin',
    logoUrl:
      'https://tipsterchat-prod-public.s3-eu-west-1.amazonaws.com/bookies/logos/Bwin.svg',
    url: '',
    isActive: true,
  },
  bf8788ghmrv8bg1f28jg: {
    id: 'bf8788ghmrv8bg1f28jg',
    code: 'WILLIAM_HILL',
    name: 'William Hill',
    logoUrl:
      'https://tipsterchat-prod-public.s3-eu-west-1.amazonaws.com/bookies/logos/WilliamHill.svg',
    url: '',
    isActive: true,
  },
  biefnbbp0dp6sqioj4i0: {
    id: 'biefnbbp0dp6sqioj4i0',
    code: 'MARATHON',
    name: 'Marathon',
    logoUrl:
      'https://tipsterchat-prod-public.s3-eu-west-1.amazonaws.com/bookies/logos/Marathon.svg',
    url: '',
    isActive: true,
  },
  bf8788ghmrv8bg1f28l0: {
    id: 'bf8788ghmrv8bg1f28l0',
    code: '888',
    name: '888Sport',
    logoUrl:
      'https://tipsterchat-prod-public.s3-eu-west-1.amazonaws.com/bookies/logos/888.svg',
    url: 'https://mmwebhandler.aff-online.com/C/43477?sr=1698901',
    isActive: true,
  },
  bf8788ghmrv8bg1f28k0: {
    id: 'bf8788ghmrv8bg1f28k0',
    code: 'BETWAY',
    name: 'Betway',
    logoUrl:
      'https://tipsterchat-prod-public.s3-eu-west-1.amazonaws.com/bookies/logos/Betway.svg',
    url: 'https://betway.es/?s=bw205743&a=bwadid75222',
    isActive: true,
  },
  biefnbrp0dp6sqioj4jg: {
    id: 'biefnbrp0dp6sqioj4jg',
    code: 'BETFAIR',
    name: 'Betfair',
    logoUrl:
      'https://tipsterchat-prod-public.s3-eu-west-1.amazonaws.com/bookies/logos/Betfair.svg',
    url: 'https://ads.betfair.com/redirect.aspx?pid=3661583&bid=3604',
    isActive: true,
  },
  boncolv2s2mbuo758a30: {
    id: 'boncolv2s2mbuo758a30',
    code: 'CODERE',
    name: 'Codere',
    logoUrl:
      'https://tipsterchat-prod-public.s3-eu-west-1.amazonaws.com/bookies/logos/Codere.svg',
    url: '',
    isActive: true,
  },
  boncomf2s2mbtlkkm790: {
    id: 'boncomf2s2mbtlkkm790',
    code: 'KIROL_BET',
    name: 'Kirol Bet',
    logoUrl:
      'https://tipsterchat-prod-public.s3-eu-west-1.amazonaws.com/bookies/logos/KirolBet.svg',

    url: 'https://adsff.kirolbet.com/redirect.aspx?pid=3978&bid=1492',
    isActive: true,
  },
  boncomn2s2mbsn1ncifg: {
    id: 'boncomn2s2mbsn1ncifg',
    code: 'LEO_VEGAS',
    name: 'Leo Vegas',
    logoUrl:
      'https://tipsterchat-prod-public.s3-eu-west-1.amazonaws.com/bookies/logos/LeoVegas.svg',

    url: 'https://ads.leovegas.com/redirect.aspx?pid=3654206&bid=15792',
    isActive: true,
  },
  boncomv2s2mbri6pll4g: {
    id: 'boncomv2s2mbri6pll4g',
    code: 'MERKUR',
    name: 'Merkur',
    logoUrl:
      'https://tipsterchat-prod-public.s3-eu-west-1.amazonaws.com/bookies/logos/Merkur.svg',
    isActive: true,
    url:
      'https://wlmerkurpartners.adsrv.eacdn.com/C.ashx?btag=a_4486b_1307c_&affid=2662&siteid=4486&adid=1307&c=',
  },
  boncon72s2mbqev3r0gg: {
    id: 'boncon72s2mbqev3r0gg',
    code: 'SPORTIUM',
    name: 'Sportium',
    logoUrl:
      'https://tipsterchat-prod-public.s3-eu-west-1.amazonaws.com/bookies/logos/Sportium.svg',
    url: '',
    isActive: true,
  },
  bonconf2s2mbpast6iv0: {
    id: 'bonconf2s2mbpast6iv0',
    code: 'STAR_VEGAS',
    name: 'Star Vegas',
    url: '',
    logoUrl:
      'https://tipsterchat-prod-public.s3-eu-west-1.amazonaws.com/bookies/logos/StarVegas.svg',
    isActive: true,
  },
  biefnb3p0dp6sqioj4gg: {
    isActive: false,
    id: 'biefnb3p0dp6sqioj4gg',
    code: 'BETFAIR_EXCHANGE',
    name: 'Betfair Exchange',
    logoUrl: '',
    url: '',
  },
  biefnbbp0dp6sqioj4h0: {
    isActive: false,
    id: 'biefnbbp0dp6sqioj4h0',
    code: 'CORAL',
    name: 'Coral',
    logoUrl: '',
    url: '',
  },
  biefnbbp0dp6sqioj4hg: {
    isActive: false,
    id: 'biefnbbp0dp6sqioj4hg',
    code: 'SPORTINGBET',
    name: 'SportingBet',
    logoUrl: '',
    url: '',
  },
  btrko7n96j4ala3kaj20: {
    id: 'btrko7n96j4ala3kaj20',
    code: 'BETFRED',
    name: 'Betfred',
    logoUrl: 'https://cdn.tipsterchat.com/bookies/logos/Betfred.svg',
    isActive: true,
    url: '',
  },
  btrko7v96j4alq9hqd00: {
    id: 'btrko7v96j4alq9hqd00',
    code: 'POKERSTARS',
    name: 'Pokerstars',
    logoUrl: 'https://cdn.tipsterchat.com/bookies/logos/Pokerstars.svg',
    isActive: true,
    url: '',
  },
  btrkv9n96j4b3had2fa0: {
    id: 'btrkv9n96j4b3had2fa0',
    code: 'WINAMAX',
    name: 'Winamax',
    logoUrl: 'https://cdn.tipsterchat.com/bookies/logos/Winamax.svg',
    isActive: true,
    url: '',
  },
  btrkv3796j4b59u0q50g: {
    id: 'btrkv3796j4b59u0q50g',
    code: 'BETHARD',
    name: 'Bethard',
    logoUrl: 'https://cdn.tipsterchat.com/bookies/logos/Bethard.svg',
    isActive: true,
    url: '',
  },
  btrkv3f96j4b5pm9hseg: {
    id: 'btrkv3f96j4b5pm9hseg',
    code: 'INTERWETTEN',
    name: 'Interwetten',
    logoUrl: 'https://cdn.tipsterchat.com/bookies/logos/Interwetten.svg',
    isActive: true,
    url: '',
  },
  btrkv3f96j4b49r4fbt0: {
    id: 'btrkv3f96j4b49r4fbt0',
    code: '1XBET',
    name: '1XBET',
    logoUrl: 'https://cdn.tipsterchat.com/bookies/logos/1xBET.svg',
    isActive: true,
    url: '',
  },
  btrkv3n96j4b4pve32gg: {
    id: 'btrkv3n96j4b4pve32gg',
    code: 'LONDON_BETTING_SHOP',
    name: 'London Betting Shop',
    logoUrl: 'https://cdn.tipsterchat.com/bookies/logos/LondonBettingShop.svg',
    isActive: true,
    url: '',
  },
  buh838v96j4fd26f7jq0: {
    id: 'buh838v96j4fd26f7jq0',
    code: 'MONDOBETS',
    name: 'Mondobets',
    logoUrl: 'https://cdn.tipsterchat.com/bookies/logos/Mondobets.svg',
    isActive: true,
    url: '',
  },
  buh839f96j4fdi67cke0: {
    id: 'buh839f96j4fdi67cke0',
    code: 'RETABET',
    name: 'Retabet',
    logoUrl: 'https://cdn.tipsterchat.com/bookies/logos/Retabet.svg',
    isActive: true,
    url: '',
  },
};

export const bookieListForSelectInput = values(bookies)
  .filter(bookie => {
    return bookie.isActive;
  })
  .reduce((accumulator: { value: string; label: string }[], current: any) => {
    accumulator.push({ value: current.id, label: current.name });
    return accumulator;
  }, [] as { value: string; label: string }[]);

export const marketListForSelectInput = markets.reduce(
  (accumulator: { key: string; title: string }[], current: string) => {
    accumulator.push({ key: current, title: current });
    return accumulator;
  },
  [] as { key: string; title: string }[],
);
